// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// // import { Button, Grid, MenuItem, Select, TextField, CircularProgress } from '@mui/material';
// import { Button, CircularProgress, Grid, MenuItem, Select, TextField, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, InputAdornment } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import TextInputs from 'src/components/inputs/TextInputs';
// import { useNavigate } from 'react-router-dom';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { Box } from '@mui/system';
// import Overview from './Overview';
// import StaffWorkTable from './StaffWorkTable';
// import TableViewFormate from './TableViewFormate';
// import * as XLSX from 'xlsx';

// const currentDate = () => {
//   const newDate = new Date();
//   const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Ensure month is two digits
//   const year = newDate.getFullYear();
//   return { month, year };
// };

// const Attendance = () => {
//   const navigate = useNavigate();
//   const [year, setYear] = useState(currentDate().year);
//   const [month, setMonth] = useState(currentDate().month);
//   const [yearMonth, setYearMonth] = useState(`${currentDate().year}-${currentDate().month}`);
//   const [selectedStaffId, setSelectedStaffId] = useState('');
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [monthlyAttendanceData, setMonthlyAttendanceData] = useState(0);
//   const [staffWorkData, setStaffWorkData] = useState([]);
//   const [showNoDataMessage, setShowNoDataMessage] = useState(false);
//   const [overviewData, setOverviewData] = useState([]);

//   // Calculate the max year-month value
//   const maxYearMonth = `${currentDate().year}-${String(currentDate().month).padStart(2, '0')}`;

//   // const { fetchAttendanceByStaffId, branchData, activeBranchId, fetchStaffWiseWork, staffOverview } = useMain();
//   const {
//     fetchAttendanceByStaffId,
//     branchData,
//     activeBranchId,
//     fetchStaffWiseWork,
//     staffOverview,
//     fetchAllStaffs,
//     setShowMessage,
//     OwnerVarification,
//     ownerData,
//     getOwnerIdByBranchId,
    
//   } = useMain();

//   // Function to handle month/year changes for attendance
//   console.log(branchData, "branchData")
//   const onApplyHandler = () => {
//     getAttendance(selectedStaffId, activeBranchId);
//   };

//    const isMasked = branchData?.isMasked || false;
  
//     /* MASK AUTH STATE */
//     const [authOpen, setAuthOpen] = useState(false);
//     const [password, setPassword] = useState('');
//     const [showPassword, setShowPassword] = useState(false);
//     const [isAuthorised, setIsAuthorised] = useState(false);
//     const [authLoading, setAuthLoading] = useState(false);
//     const [ownerId, setOwnerId] = useState(null);
  
//     /* CHECK STORED ACCESS */
//     // useEffect(() => {
//     //   if (!isMasked) {
//     //     setIsAuthorised(true);
//     //     return;
//     //   }
  
//     //   const ts = localStorage.getItem('reportAccessTimestamp');
//     //   if (ts && Date.now() - ts < 10 * 60 * 1000) {
//     //     setIsAuthorised(true);
//     //   } else {
//     //     setAuthOpen(true);
//     //   }
//     // }, [isMasked]);
//     useEffect(() => {
//   if (!isMasked) {
//     setIsAuthorised(true);
//     return;
//   }

//   const ts = localStorage.getItem('reportAccessTimestamp');
//   if (ts && Date.now() - ts < 10 * 60 * 1000) {
//     setIsAuthorised(true);
//      setAuthOpen(false);
//       setPassword('');
//       setShowPassword(false);
//   }
//   // ✅ dialog opens only after ownerId loads — handled below
// }, [isMasked]);

// useEffect(() => {
//   if (!isMasked || isAuthorised) return;
//   if (ownerId) {
//     setAuthOpen(true); // ✅ only opens once ownerId is ready
//   }
// }, [ownerId, isMasked, isAuthorised]);

//     /* FETCH OWNER ID ON MOUNT/TAB OPEN */
//     useEffect(() => {
//       // const fetchOwnerIdOnLoad = async () => {
//       //   const branchId = activeBranchId || branchData?._id || localStorage.getItem('branchId');
//       //   if (branchId && typeof getOwnerIdByBranchId === 'function') {
//       //     const ownerRes = await getOwnerIdByBranchId(branchId);
//       //     const extractedId = ownerRes?.data?.ownerId || ownerRes?.ownerId || ownerRes?.data?._id;
//       //     const finalId = (typeof extractedId === 'object' && extractedId?._id) ? extractedId._id : extractedId;
//       //     if (typeof finalId === 'string') {
//       //       setOwnerId(finalId);
//       //     }
//       //   }
//       // };
//       const fetchOwnerIdOnLoad = async () => {
//   const branchId = activeBranchId || branchData?._id || localStorage.getItem('branchId');
//   console.log('STEP 1 - branchId:', branchId);
//   console.log('STEP 2 - getOwnerIdByBranchId type:', typeof getOwnerIdByBranchId);

//   if (branchId && typeof getOwnerIdByBranchId === 'function') {
//     const ownerRes = await getOwnerIdByBranchId(branchId);
//     console.log('STEP 3 - full ownerRes:', JSON.stringify(ownerRes));

//     const extractedId = ownerRes?.data?.ownerId || ownerRes?.ownerId || ownerRes?.data?._id;
//     console.log('STEP 4 - extractedId:', extractedId);

//     const finalId = (typeof extractedId === 'object' && extractedId?._id) ? extractedId._id : extractedId;
//     console.log('STEP 5 - finalId:', finalId, '| type:', typeof finalId);

//     if (typeof finalId === 'string') {
//       setOwnerId(finalId);
//       console.log('STEP 6 - ownerId SET successfully:', finalId);
//     } else {
//       console.log('STEP 6 - ownerId NOT set, finalId was not a string');
//     }
//   } else {
//     console.log('STEP 1 FAILED - branchId missing or function missing');
//   }
// };
//       fetchOwnerIdOnLoad();
//     }, [activeBranchId, branchData?._id, getOwnerIdByBranchId]);
  
//     /* PASSWORD SUBMIT  */
//     // const handleAuthSubmit = async () => {
//     //   if (!password) {
//     //     setShowMessage({ message: 'Enter login password', messageType: 'error' });
//     //     return;
//     //   }
  
//     //   try {
//     //     setAuthLoading(true);
//     //     const branchId = activeBranchId || branchData?._id || localStorage.getItem('branchId');

//     //     if (!branchId) {
//     //       setShowMessage({ message: 'Branch information not found', messageType: 'error' });
//     //       setAuthLoading(false);
//     //       return;
//     //     }

//     //     let currentOwnerId = ownerId;

//     //     // 1. Try to get Owner ID if not already pre-fetched
//     //     if (!currentOwnerId && typeof getOwnerIdByBranchId === 'function') {
//     //       const ownerRes = await getOwnerIdByBranchId(branchId);
//     //       const extractedId = ownerRes?.data?.ownerId || ownerRes?.ownerId || ownerRes?.data?._id;
//     //       const finalId = (typeof extractedId === 'object' && extractedId?._id) ? extractedId._id : extractedId;

//     //       if (finalId && typeof finalId === 'string') {
//     //         currentOwnerId = finalId;
//     //       }
//     //     }

//     //     // 2. Fallback to existing data only if the API call didn't return a valid string ID
//     //     if (!currentOwnerId || typeof currentOwnerId !== 'string') {
//     //       if (ownerData?._id && typeof ownerData._id === 'string') {
//     //         currentOwnerId = ownerData._id;
//     //       } else if (branchData) {
//     //         if (branchData.ownerId && typeof branchData.ownerId === 'string') {
//     //           currentOwnerId = branchData.ownerId;
//     //         } else if (branchData.owner && typeof branchData.owner === 'object' && branchData.owner._id && typeof branchData.owner._id === 'string') {
//     //           currentOwnerId = branchData.owner._id;
//     //         } else if (branchData.owner && typeof branchData.owner === 'string') {
//     //           currentOwnerId = branchData.owner;
//     //         }
//     //       }
//     //     }

//     //     // Final check to prevent "[object Object]" in the API URL
//     //     if (!currentOwnerId || typeof currentOwnerId !== 'string') {
//     //       setShowMessage({ message: 'Owner ID not found for this branch', messageType: 'error' });
//     //       setAuthLoading(false);
//     //       return;
//     //     }

//     //     const res = await OwnerVarification(currentOwnerId, { password });
  
//     //     if (res?.statusCode === 200) {
//     //       localStorage.setItem('reportAccessTimestamp', Date.now());
//     //       setIsAuthorised(true);
//     //       setAuthOpen(false);
//     //       setPassword('');
//     //     } else {
//     //       setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
//     //     }
//     //   } catch (err) {
//     //     console.error("Auth error:", err);
//     //     setShowMessage({ message: 'Something went wrong', messageType: 'error' });
//     //   } finally {
//     //     setAuthLoading(false);
//     //   }
//     // };
//   const handleAuthSubmit = async () => {
//   if (!password) {
//     setShowMessage({ message: 'Enter login password', messageType: 'error' });
//     return;
//   }

//   if (!ownerId) {
//     setShowMessage({ message: 'Owner ID not found. Please refresh and try again.', messageType: 'error' });
//     return;
//   }

//   try {
//     setAuthLoading(true);
//     const res = await OwnerVarification(ownerId, { password });

//     if (res?.statusCode === 200) {
//       localStorage.setItem('reportAccessTimestamp', Date.now());
//       setIsAuthorised(true);
//       setAuthOpen(false);
//       setPassword('');
//     } else {
//       setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
//     }
//   } catch (err) {
//     console.error("Auth error:", err);
//     setShowMessage({ message: 'Something went wrong', messageType: 'error' });
//   } finally {
//     setAuthLoading(false);
//   }
// };
//     /*  MASK VALUE HELPER  */
//     const maskValue = (value) => {
//       if (!isMasked || isAuthorised) return value;
//       if (value === null || value === undefined) return value;
//       return '****';
//     };
  
//     const handleCloseDialogue = () => {
//       navigate(-1);
//       setPassword('');
//       setShowPassword(false);
//     };
//   const onStaffWorkHandler = () => {
//     getStaffWork(selectedStaffId, activeBranchId, month);
//   };

//   const handleStaffChange = (event) => {
//     setSelectedStaffId(event.target.value);
//     setShowNoDataMessage(false);
//   };

//   // Function to get the max date for the input (current month)
//   const getMaxYearMonth = () => {
//     const { year, month } = currentDate();
//     return `${year}-${month}`;
//   };

//   const getStaffOverview = async (id, yearMonth) => {
//     // const getStaffOverview = async (id, month, year) => {
//     try {
//       setLoading(true);
//       const res = await staffOverview(id, activeBranchId, yearMonth);
//       if (res.statusCode === 200) {
//         setOverviewData(res?.data || []);
//       }
//     } catch (error) {
//       console.error('Error fetching overview data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getAttendance = async (id, branchId) => {
//     const queryParams = `?branchId=${branchId}&month=${yearMonth}`;
//     try {
//       setLoading(true);
//       const res = await fetchAttendanceByStaffId(id, queryParams);
//       if (res.statusCode === 200) {
//         setMonthlyAttendanceData(res?.data?.totalAttendance);
//         setData(res?.data?.attendanceData || []);
//       }
//     } catch (error) {
//       console.error('Error fetching attendance data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getStaffWork = async (id, activeBranchId, monthName) => {
//     const queryParams = `&staffId=${id}&monthName=${monthName}`;
//     try {
//       setLoading(true);
//       const res = await fetchStaffWiseWork(activeBranchId, queryParams);
//       if (res.statusCode === 200) {
//         setStaffWorkData(res?.data || []);
//         setShowNoDataMessage(res?.data?.length === 0);
//       }
//     } catch (error) {
//       console.error('Error fetching staff work data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // if (selectedStaffId && activeBranchId) {
//         if (selectedStaffId && activeBranchId && isAuthorised) {

//       getAttendance(selectedStaffId, activeBranchId);
//       getStaffOverview(selectedStaffId, yearMonth);
//     }
//     return () => {
//       setData([]);
//       setMonthlyAttendanceData(0);
//       setOverviewData([]);
//       setStaffWorkData([]);
//     };
//   // }, [selectedStaffId, activeBranchId, yearMonth]);
//     }, [selectedStaffId, activeBranchId, yearMonth, month, year, isAuthorised]);


//   const exportToExcel = () => {
//     // Staff name retrieval
//     const selectedStaff = branchData?.staffs?.find(staff => staff._id === selectedStaffId);
//     const staffName = selectedStaff ? selectedStaff.name : 'Unknown Staff';

//     // Define headers
//     const headers = ['Date', 'Day', 'In Time', 'Out Time', 'Attendance', 'Effective Hours', 'Appointments'];

//     // Convert data to required format
//     const excelData = data.map((item) => {
//       const originalDate = item?.date;
//       let formattedDate = '';
//       if (originalDate) {
//         const [year, month, day] = originalDate.split('-');
//         formattedDate = `${day}-${month}-${year}`;
//       }

//       return {
//         Date: formattedDate,
//         Day: item?.day || '',
//         'In Time': item?.attendance?.inTime || '--:--',
//         'Out Time': item?.attendance?.outTime || '--:--',
//         Attendance: item?.attendance?.status || '',
//         'Effective Hours': item?.effectiveWorkInHours || '',
//         Appointments: 'View Details',
//       };
//     });

//     // Create worksheet and workbook
//     const worksheet = XLSX.utils.json_to_sheet([]);

//     // Insert staff name at the top
//     XLSX.utils.sheet_add_aoa(worksheet, [[`Staff Name: ${staffName}`]], { origin: 'A1' });

//     // Insert headers at row 3
//     XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A3' });

//     // Insert data starting from row 4
//     XLSX.utils.sheet_add_json(worksheet, excelData, { origin: 'A4', skipHeader: true });

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Data');

//     // Download the Excel file
//     XLSX.writeFile(workbook, `Attendance_Report_${staffName}.xlsx`);
//   };



//    /* BLOCK UI IF NOT AUTHORISED  */
//     if (isMasked && !isAuthorised) {
//   return (
//     <PageContainer title="Attendance" description="This is staff attendance">
//           <DashboardCard2 title="Staff Attendance">
//             <Dialog open={authOpen} onClose={handleCloseDialogue}>
//               <DialogTitle>Confirm Request</DialogTitle>
//               <DialogContent>
//                 <DialogContentText>
//                   Please enter the owner password to access this page.
//                 </DialogContentText>
//                 <Box style={{ marginTop: '10px' }}>
//                   <Grid container spacing={3}>
//                     <Grid item xs={12}>
//                       <TextInputs
//                         title="Login Password"
//                         name="password"
//                         type={showPassword ? 'text' : 'password'}
//                         value={password}
//                         handleChange={(e) => setPassword(e.target.value)}
//                         disabled={authLoading}
//                         InputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <IconButton
//                                 onClick={() => setShowPassword((prev) => !prev)}
//                                 edge="end"
//                                 disabled={authLoading}
//                               >
//                                 {showPassword ? <Visibility /> : <VisibilityOff />}
//                               </IconButton>
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={handleCloseDialogue}>Cancel</Button>
//                 <Button onClick={handleAuthSubmit} disabled={authLoading}>
//                   {authLoading ? 'Verifying...' : 'Submit'}
//                 </Button>
//               </DialogActions>
//             </Dialog>
//           </DashboardCard2>
//         </PageContainer>
//       );
//     }

//   return (
//     <PageContainer title="Attendance" description="This is staff attendance">
//       <DashboardCard2 title="Staff Attendance">
//         <Overview overviewData={overviewData} selectedStaffId={selectedStaffId} />
//         <Grid container spacing={2} sx={{ mt: 1, mb: 3 }} alignItems="center">
//           <Grid item xs={6}>
//             <Select
//               value={selectedStaffId || ''}
//               onChange={handleStaffChange}
//               displayEmpty
//               style={{
//                 borderRadius: '7px',
//                 border: '0.5px solid #6174DD',
//                 padding: '4px 12px',
//                 background: '#FFF',
//                 height: '40px',
//                 minWidth: '140px',
//               }}
//                  MenuProps={{
//                 PaperProps: {
//                   style: {
//                     maxHeight: 350, // 🔒 Restrict dropdown height
//                     overflowY: 'auto',
//                     zIndex: 1300,
//                   },
//                 },
//               }}
//             >
//               <MenuItem value="" disabled>
//                 {branchData?.staffs ? (
//                   'Select Staff'
//                 ) : (
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={16} color="inherit" /> Loading...
//                   </Box>
//                 )}
//               </MenuItem>
//               {branchData?.staffs ? (
//                 branchData.staffs
//                   ?.filter((staff) => staff.active !== false) // Ensure active staff are visible
//                   .map((staff) => (
//                     <MenuItem key={staff._id} value={staff._id}>
//                       {staff.name}
//                     </MenuItem>
//                   ))
//               ) : (
//                 <MenuItem disabled sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
//                   <CircularProgress size={20} />
//                 </MenuItem>
//               )}
//             </Select>
//           </Grid>

//           {/* Button ko ek hi row me sahi align karna */}
//           <Grid item xs={6} container justifyContent="flex-end" alignItems="center">
//             <TextField
//               type="month"
//               value={yearMonth}
//               onChange={(e) => setYearMonth(e.target.value)}
//               InputLabelProps={{ shrink: true }}
//               sx={{
//                 '& input': {
//                   fontSize: '0.8rem',
//                   padding: '0.5rem',
//                 },
//                 width: '120px',
//               }}
//               inputProps={{
//                 max: maxYearMonth,
//               }}
//             />
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={exportToExcel}
//               sx={{ ml: 2 }}
//             >
//               Download Excel
//             </Button>
//           </Grid>
//         </Grid>
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <>
//             {staffWorkData.length === 0 ? (
//               showNoDataMessage ? (
//                 <div className="no-data-message">
//                   No work has been done by selected Staff.
//                 </div>
//               ) : (
//                 <TableViewFormate
//                   data={data}
//                   selectedStaffId={selectedStaffId}
//                   getAttendance={getAttendance}
//                   getStaffOverview={getStaffOverview}
//                   yearMonth={yearMonth}
//                 />
//               )
//             ) : (
//               <StaffWorkTable
//                 selectedStaffId={selectedStaffId}
//                 data={staffWorkData}
//                 getStaffWork={getStaffWork}
//                 getStaffOverview={getStaffOverview}
//               />
//             )}
//           </>
//         )}
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default Attendance;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import {
  Button, CircularProgress, Grid, TextField, Dialog, DialogTitle,
  DialogContent, DialogContentText, DialogActions, IconButton, InputAdornment,
  Box, Paper, Stack, Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  ChecklistRtlOutlined,
  HourglassEmptyOutlined,
  TaskAltOutlined,
  CancelOutlined,
} from '@mui/icons-material';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import TextInputs from 'src/components/inputs/TextInputs';
import StaffWorkTable from './StaffWorkTable';
import AttendanceCalendar from './components/AttendanceCalendar';
import StaffLeaveLog from './components/StaffLeaveLog';
import * as XLSX from 'xlsx';
import Overview from './Overview';
const THEME = '#6174DD';

const currentDate = () => {
  const newDate = new Date();
  const month = String(newDate.getMonth() + 1).padStart(2, '0');
  const year = newDate.getFullYear();
  return { month, year };
};

const Attendance = () => {
  const [yearMonth, setYearMonth] = useState(`${currentDate().year}-${currentDate().month}`);
  const [selectedStaffId, setSelectedStaffId] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [monthlyAttendanceData, setMonthlyAttendanceData] = useState(0);
  const [staffWorkData, setStaffWorkData] = useState([]);
  const [showNoDataMessage, setShowNoDataMessage] = useState(false);
  const [overviewData, setOverviewData] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [loadingStaffs, setLoadingStaffs] = useState(false);

  // Branch-wide leave counts for the top summary cards (all staff, not just the selected one)
  const [leaveCounts, setLeaveCounts] = useState({ all: 0, pending: 0, approved: 0, rejected: 0 });

  const maxYearMonth = `${currentDate().year}-${String(currentDate().month).padStart(2, '0')}`;

  const {
    fetchAttendanceByStaffId, branchData, activeBranchId, fetchStaffWiseWork, staffOverview,
    fetchAllStaffs, setShowMessage, OwnerVarification, ownerData, getAllLeaveRequestsByBranch,
  } = useMain();

  const isMasked = branchData?.isMasked || false;

  /* MASK AUTH STATE */
  const [authOpen, setAuthOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);

  useEffect(() => {
    if (!isMasked) {
      setIsAuthorised(true);
      return;
    }
    const ts = localStorage.getItem('reportAccessTimestamp');
    if (ts && Date.now() - ts < 10 * 60 * 1000) {
      setIsAuthorised(true);
    } else {
      setAuthOpen(true);
    }
  }, [isMasked]);

  const handleAuthSubmit = async () => {
    if (!password) {
      setShowMessage({ message: 'Enter login password', messageType: 'error' });
      return;
    }
    try {
      setAuthLoading(true);
      const res = await OwnerVarification(ownerData?._id, { password });
      if (res?.statusCode === 200) {
        localStorage.setItem('reportAccessTimestamp', Date.now());
        setIsAuthorised(true);
        setAuthOpen(false);
        setPassword('');
        setShowPassword(false);
      } else {
        setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
      }
    } catch (err) {
      setShowMessage({ message: 'Something went wrong', messageType: 'error' });
    } finally {
      setAuthLoading(false);
    }
  };

  const handleCloseDialogue = () => {
    setAuthOpen(false);
    setPassword('');
    setShowPassword(false);
  };

  const getStaffOverview = async (id, ym) => {
    try {
      setLoading(true);
      const res = await staffOverview(id, activeBranchId, ym);
      if (res.statusCode === 200) {
        setOverviewData(res?.data || []);
      }
    } catch (error) {
      console.error('Error fetching overview data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getAttendance = async (id, branchId) => {
    const queryParams = `?branchId=${branchId}&month=${yearMonth}`;
    try {
      setLoading(true);
      const res = await fetchAttendanceByStaffId(id, queryParams);
      if (res.statusCode === 200) {
        setMonthlyAttendanceData(res?.data?.totalAttendance);
        setData(res?.data?.attendanceData || []);
      }
    } catch (error) {
      console.error('Error fetching attendance data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStaffWork = async (id, branchId, monthName) => {
    const queryParams = `&staffId=${id}&monthName=${monthName}`;
    try {
      setLoading(true);
      const res = await fetchStaffWiseWork(branchId, queryParams);
      if (res.statusCode === 200) {
        setStaffWorkData(res?.data || []);
        setShowNoDataMessage(res?.data?.length === 0);
      }
    } catch (error) {
      console.error('Error fetching staff work data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStaffs = async () => {
    try {
      setLoadingStaffs(true);
      const res = await fetchAllStaffs(activeBranchId);
      if (res.statusCode === 200) {
        const activeStaffs = (res?.data || []).filter((staff) => staff.active);
        setStaffs(activeStaffs);
        // Default-select the first staff member once the list loads, if nothing is selected yet.
        if (activeStaffs.length && !selectedStaffId) {
          setSelectedStaffId(activeStaffs[0]._id);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingStaffs(false);
    }
  };

  const getLeaveCounts = async () => {
    try {
      const res = await getAllLeaveRequestsByBranch(activeBranchId);
      if (res?.statusCode === 200) {
        setLeaveCounts(res?.data?.counts || { all: 0, pending: 0, approved: 0, rejected: 0 });
      }
    } catch (error) {
      console.error('Error fetching leave counts:', error);
    }
  };

  useEffect(() => {
    if (selectedStaffId && activeBranchId && isAuthorised) {
      getAttendance(selectedStaffId, activeBranchId);
      getStaffOverview(selectedStaffId, yearMonth);
    }
    return () => {
      setData([]);
      setMonthlyAttendanceData(0);
      setOverviewData([]);
      setStaffWorkData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStaffId, activeBranchId, yearMonth, isAuthorised]);

  useEffect(() => {
    if (activeBranchId && isAuthorised) {
      getStaffs();
      getLeaveCounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeBranchId, isAuthorised]);

  const exportToExcel = () => {
    const selectedStaff = staffs.find((staff) => staff._id === selectedStaffId);
    const staffName = selectedStaff ? selectedStaff.name : 'Unknown Staff';

    const headers = ['Date', 'Day', 'In Time', 'Out Time', 'Attendance', 'Effective Hours', 'Appointments'];

    const excelData = data.map((item) => {
      const originalDate = item?.date;
      let formattedDate = '';
      if (originalDate) {
        const [y, m, d] = originalDate.split('-');
        formattedDate = `${d}-${m}-${y}`;
      }
      return {
        Date: formattedDate,
        Day: item?.day || '',
        'In Time': item?.attendance?.inTime || '--:--',
        'Out Time': item?.attendance?.outTime || '--:--',
        Attendance: item?.attendance?.status || '',
        'Effective Hours': item?.effectiveWorkInHours || '',
        Appointments: 'View Details',
      };
    });

    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [[`Staff Name: ${staffName}`]], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A3' });
    XLSX.utils.sheet_add_json(worksheet, excelData, { origin: 'A4', skipHeader: true });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Data');
    XLSX.writeFile(workbook, `Attendance_Report_${staffName}.xlsx`);
  };

  const selectedStaffName = staffs.find((s) => s._id === selectedStaffId)?.name;

  /* BLOCK UI IF NOT AUTHORISED */
  if (isMasked && !isAuthorised) {
    return (
      <PageContainer title="Attendance" description="This is staff attendance">
        <DashboardCard2 title="Staff Attendance">
          <Dialog open={authOpen} onClose={handleCloseDialogue}>
            <DialogTitle>Confirm Request</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please enter the owner password to access this page.
              </DialogContentText>
              <Box style={{ marginTop: '10px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextInputs
                      title="Login Password"
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      handleChange={(e) => setPassword(e.target.value)}
                      disabled={authLoading}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" disabled={authLoading}>
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialogue}>Cancel</Button>
              <Button onClick={handleAuthSubmit} disabled={authLoading}>
                {authLoading ? 'Verifying...' : 'Submit'}
              </Button>
            </DialogActions>
          </Dialog>
        </DashboardCard2>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Attendance" description="This is staff attendance">
      <DashboardCard2 title="Staff Attendance">
        {/* ---- Top summary cards (branch-wide leave counts) ---- */}
        {/* <Grid container spacing={3} sx={{ mb: 3 }}>
          {[
            { no: leaveCounts.all, label: 'ALL REQUESTS', color: '#FF5E1C', icon: <ChecklistRtlOutlined sx={{ color: '#6174DD' }} /> },
            { no: leaveCounts.pending, label: 'PENDING', color: '#02C4A9', icon: <HourglassEmptyOutlined sx={{ color: '#FF5E1B' }} /> },
            { no: leaveCounts.approved, label: 'APPROVED', color: '#3171FB', icon: <TaskAltOutlined sx={{ color: '#03C4A9' }} /> },
            { no: leaveCounts.rejected, label: 'REJECTED', color: '#FBCA2C', icon: <CancelOutlined sx={{ color: '#D93025' }} /> },
          ].map((item, index) => (
            <Grid item xs={6} md={3} key={index}>
              <Paper
                elevation={3}
                style={{
                  backgroundColor: item.color,
                  textAlign: 'center',
                  height: '120px',
                  padding: '20px 20px',
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                  borderRadius: '10px',
                  gap: '10px',
                }}
              >
                <Stack direction="row" spacing={2} width="100%" alignItems="flex-start" justifyContent="space-between">
                  <IconButton sx={{ background: 'white', '&:hover': { background: 'white' } }}>
                    {item.icon}
                  </IconButton>
                </Stack>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ color: '#fff', fontWeight: '900', fontSize: '25px' }}>{item.no}</div>
                  <div style={{ color: '#fff', fontWeight: '600' }}>{item.label}</div>
                </div>
              </Paper>
            </Grid>
          ))}
        </Grid> */}
        <Box sx={{ mb: 3 }}>
          <Overview overviewData={overviewData} selectedStaffId={selectedStaffId} />
        </Box>

        {/* ---- Staff list as buttons + month picker + export ---- */}

        {/* ---- Staff list as buttons + month picker + export ---- */}
        <Box
          sx={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexWrap: 'wrap', gap: 2, mb: 5,
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {loadingStaffs ? (
              <CircularProgress size={22} />
            ) : (
              staffs.map((staff) => {
                const active = staff._id === selectedStaffId;
                return (
                  <Button
                    key={staff._id}
                    onClick={() => { setSelectedStaffId(staff._id); setShowNoDataMessage(false); }}
                    variant={active ? 'contained' : 'outlined'}
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '20px',
                      borderColor: THEME,
                      color: active ? '#fff' : THEME,
                      background: active ? `linear-gradient(135deg, ${THEME}, #4a5bc7)` : '#fff',
                      '&:hover': {
                        background: active ? `linear-gradient(135deg, ${THEME}, #4a5bc7)` : '#f0f2ff',
                        borderColor: THEME,
                      },
                    }}
                  >
                    {staff.name}
                  </Button>
                );
              })
            )}
            {!loadingStaffs && staffs.length === 0 && (
              <Typography sx={{ color: '#888', fontSize: '0.85rem' }}>No active staff found.</Typography>
            )}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, ml: 'auto' }}>
            {/* <TextField
              type="month"
              value={yearMonth}
              onChange={(e) => setYearMonth(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ '& input': { fontSize: '0.8rem', padding: '0.5rem' }, width: '120px' }}
              inputProps={{ max: maxYearMonth }}
            /> */}
            <Button variant="contained"  color="primary" onClick={exportToExcel}>
              Download Excel
            </Button>
          </Box>
        </Box>

        {/* ---- Left: attendance calendar   Right: staff-specific leave log ---- */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={8.5}>
            <AttendanceCalendar
              selectedStaffId={selectedStaffId}
              staffs={staffs}
              data={data}
              activeBranchId={activeBranchId}
              yearMonth={yearMonth}
              setYearMonth={setYearMonth}
              maxYearMonth={maxYearMonth}
              onEntryChanged={() => {
                if (selectedStaffId && activeBranchId) getAttendance(selectedStaffId, activeBranchId);
                getLeaveCounts();
              }}
            />
          </Grid>
          <Grid item xs={12} md={3.5}>
            <StaffLeaveLog
              selectedStaffId={selectedStaffId}
              staffName={selectedStaffName}
              activeBranchId={activeBranchId}
              yearMonth={yearMonth}
            />
          </Grid>
        </Grid>

        {/* ---- Appointment / Work data (unchanged) ---- */}
        {loading ? (
          <ShowLoader />
        ) : (
          <>
            {staffWorkData.length === 0 ? (
              showNoDataMessage && (
                <div className="no-data-message">No work has been done by selected Staff.</div>
              )
            ) : (
              <StaffWorkTable
                selectedStaffId={selectedStaffId}
                data={staffWorkData}
                getStaffWork={getStaffWork}
                getStaffOverview={getStaffOverview}
              />
            )}
          </>
        )}
      </DashboardCard2>
    </PageContainer>
  );
};

export default Attendance;